import React, { useState } from "react";
import NewButton from "../../../NewComponents/NewButton";
import { ReactComponent as Close } from "../../../assets/icons/x.svg";

const BillingPeriodPopUp = ({
  billingPeriod,
  setBillingPeriod,
  setShowPeriodPopUp,
  onSave,
}) => {
  const [period, setPeriod] = useState(
    billingPeriod ? billingPeriod : 8
  );

  return (
    <div className="newPopUpModalWrap">
      <div className="newPopUpModalContainer">
        <h2 className="newPopUpModalTitle">Own Billing Period</h2>
        <div className="newPopUpModalContent">
          <div className="billingPopUpModalTextWrap">
            <p className="billingPopUpModalText">
              Own period during which automatic payment will occur each time.
              (not less than 8 and not more than 90 days)
            </p>
            <div className="billingPeriodInputWrap">
              <p className="billingPopUpModalText">Every</p>
              <input
                placeholder="0"
                type="number"
                className="billingPeriodInput"
                maxLength={2}
                value={period}
                onChange={(e) =>
                  e.target.value.length <= 2 && setPeriod(e.target.value)
                }
              />
              <p className="billingPopUpModalText">days</p>
            </div>
          </div>
        </div>
        <div className="newPopUpModalTextWrap">
          <NewButton
            disabled={!period || period < 8 || period > 90}
            text={"Save"}
            width="100%"
            onClick={() => {
              onSave("own", period);
            }}
          />
          <NewButton
            text={"Cancel"}
            width="100%"
            onClick={() => setShowPeriodPopUp(false)}
            back
            icon={false}
            whiteBtn
          />
        </div>
        <Close
          className="newPopUpModalCloseIcon"
          onClick={() => setShowPeriodPopUp(false)}
        />
      </div>
    </div>
  );
};

export default BillingPeriodPopUp;
